<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card" v-if="1>2">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col"></div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'examModal', model:{}})"
                                    class="btn btn-info btn-sm"
                                >{{$t('New exam')}}</button>
                                <!-- <button
                                    @click="openModal({id:'treatmentModal', model:{}})"
                                    class="btn btn-warning btn-sm ml-2"
                                >New treatment</button>-->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card card-inactive" v-if="exams.length == 0">
                    <div class="card-body text-center text-muted small">
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-10 col-xl-8">
                                <!-- Image -->
                                <img
                                    src="@/assets/img/illustrations/lost.svg"
                                    alt="..."
                                    class="img-fluid mt-n5 mb-4"
                                    style="max-width: 272px;"
                                />
                                <h2>{{$t('Exams')}}</h2>
                                <p class="text-muted">{{$t('All exams history will be here')}}</p>

                                <button
                                    @click="openModal({id:'examModal', model:{}})"
                                    class="btn btn-primary"
                                >{{$t('New exam')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-for="(exam, examIdx) in exams" :key="examIdx">
                    <div class="card mb-2">
                        <div class="card-header" @click="toggleExam(examIdx)">
                            <div class="row align-items-center">
                                <div class="col-auto small">
                                    <user :user="exam.user._id" />
                                </div>
                                <div class="col"></div>
                                <div class="col-auto">
                                    <span
                                        class="badge"
                                        :class="{'badge-info':exam.type == 'exam', 'badge-warning':exam.type == 'treat'}"
                                    >{{ exam.type }}</span>
                                    {{exam.createdAt | moment('calendar')}}
                                </div>

                                <div class="col-auto">
                                    <button
                                        class="btn btn-white ml-2 btn-sm"
                                        @click="openModal({id:'examViewModal', model:exam})"
                                    >
                                        <i class="fe fe-printer"></i>
                                    </button>
                                    <button
                                        class="btn btn-white ml-2 btn-sm"
                                        @click="openModal({id:'examModal', model:exam})"
                                    >
                                        <i class="fe fe-edit"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" v-if="visible == examIdx">
                            <div class="row align-items-start">
                                <div class="col-6 small mb-3">
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Complaints')}}</h6>
                                    <ul>
                                        <li v-for="(item, index) in exam.cdb" :key="index">{{ item.label }}</li>
                                    </ul>
                                </div>
                                <div class="col-6 small mb-3">
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Objectively')}}</h6>
                                    <ul>
                                        <li v-for="(item, index) in exam.odb" :key="index">
                                            {{ item.label }}:
                                            <b>{{ item.value }}</b>
                                        </li>
                                    </ul>

                                    <!-- <p v-if="exam.objectively.length">{{ exam.objectively }}</p> -->
                                </div>
                                <div class="col-6 small mb-3" v-if="exam.diagnosis.length>0">
                                    <h6
                                        class="card-title text-uppercase text-muted mb-2"
                                    >{{$t('Preliminary diagnosis')}}</h6>
                                    <ul>
                                        <li v-for="(item, index) in exam.diagnosis" :key="index">
                                            <strong>{{item.code}}</strong>
                                            {{ item.label }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-6 small mb-3" v-if="exam.diagnosisFinal.length>0">
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Final diagnosis')}}</h6>
                                    <ul>
                                        <li v-for="(item, index) in exam.diagnosisFinal" :key="index">
                                            <strong>{{item.code}}</strong>
                                            {{ item.label }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <exam-modal id="examModal" :data="model"></exam-modal> -->
        <exam-view-modal id="examViewModal" :data="model"></exam-view-modal>
    </div>
</template>

<script>
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
// import ExamModal from './ExamModal.vue';
import ExamViewModal from './ExamViewModal.vue';
import Avatar from '@/components/Avatar.vue';
import User from '@/components/User.vue';

export default {
    mixins: [modalMixins],
    components: {
        User,
        Avatar,
        ExamViewModal,
        // ExamModal,
    },
    data() {
        return {
            visible: 0,
            params: {
                query: {
                    $limit: 100,
                    customerId: this.$route.params.id,
                    $sort: {
                        createdAt: -1
                    }
                }
            },

        }
    },
    created() {
        this.queryExams();
    },
    computed: {
        ...mapState('exam', { areExamsLoading: 'isFindPending' }),
        ...mapGetters('exam', { findExamsInstore: 'find' }),
        ...mapGetters('specialty', { specialty: 'get' }),

        exams() {
            return this.findExamsInstore(this.params).data;
        },

    },
    methods: {
        ...mapActions('exam', ['find', 'create', 'patch', 'remove', 'get']),



        toggleExam(index) {
            this.visible = index;
        },
        queryExams() {
            this.find(this.params)
        }
    }
}
</script>

<style>

</style>
